export default __webpack_public_path__ + "static/about-us-2-0e4ea9f8e6322fb01ab694a0ab745920.png";